import {
  SEARCH_INPUT_CHANGED,
  SEARCH_RESULTS,
  POINTER_INSIDE_NAV_BOX,
  SHOW_SEARCH_RESULTS,
  NAV_INDEX_CHANGED,
  ITEM_SELECTED
} from './search-box-consts';
import settings from './../../../config.js';

export function searchInputChanged(input) {
  return (dispatch, getState) => {

    const { rootReducer } = getState();

      dispatch({
        type: SEARCH_INPUT_CHANGED,
        payload: {
          searchWord: input,
          bDataIsLoading: true
        }
      });

      let result = rootReducer.treeNodes.filter(elem => elem.name.indexOf(input) !== -1 ? true : false );

      dispatch({
        type: SEARCH_RESULTS,
        payload: {
          searchResults:  result.length > 0 ? result : [],
          bDataIsLoading: false
        }
      });

  };
}

export function setPointerInsideNavBox(bInside) {
  return {
    type: POINTER_INSIDE_NAV_BOX,
    payload: {bPointerInsideNavBox: bInside}
  };
}

export function setShowSearchResults(bShow) {
  return {
    type: SHOW_SEARCH_RESULTS,
    payload: {bShowSearchResults: bShow}
  };
}

export function navIndexChanged(nIndex) {
  return {
    type: NAV_INDEX_CHANGED,
    payload: {nNavIndex: nIndex}
  };
}

export function itemSelected(nIndex) {
  return {
    type: ITEM_SELECTED,
    payload: {nNavIndex: nIndex}
  };
}



/** WEBPACK FOOTER **
 ** app/components/search-box/state/search-box-actions.js
 **/